'use client'

import dynamic from 'next/dynamic'
import { memo, useState } from 'react'
import Carousel from './carousel'

const ModalDialog = dynamic(() =>
  import('@dustin-web/microsite-components/src/modal-dialog').then(mod => mod.ModalDialog)
)

type Props = {
  productImages: string[]
  productName: string
  isSmallScreen: boolean
}

const ProductGallery = ({ productImages, productName, isSmallScreen }: Props) => {
  const [modalState, setModalState] = useState({ isOpen: false, slideIndex: 0 })

  return (
    <>
      <Carousel
        initialIndex={modalState.slideIndex}
        isFullScreen={false}
        setModalState={setModalState}
        imageFilenames={productImages || []}
        isSmallScreen={isSmallScreen}
      />
      {modalState.isOpen && (
        <ModalDialog
          show
          size="xl"
          disableFocusLock
          disableAnimation
          boxStyle={{
            maxWidth: '90vw',
            height: '100vh',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'clip',
          }}
          className="justify-content-center"
          fullscreen={isSmallScreen}
          ariaLabel={`Images of the product ${productName}`}
          handleClose={() => setModalState({ isOpen: false, slideIndex: 0 })}>
          <Carousel
            isFullScreen
            initialIndex={modalState.slideIndex}
            setModalState={setModalState}
            imageFilenames={productImages || []}
            isSmallScreen={isSmallScreen}
          />
        </ModalDialog>
      )}
    </>
  )
}

// only re-render when actual image content changes
export default memo(ProductGallery, (prev, next) => {
  if (prev.isSmallScreen !== next.isSmallScreen) return false
  if (prev.productName !== next.productName) return false
  if (prev.productImages.length !== next.productImages.length) return false
  return prev.productImages.every((img, i) => img === next.productImages[i])
})
